<template>
  <a-modal
    :title="title"
    :visible="visible"
    :footer="null"
    :width="860"
    destroy-on-close
    @cancel="close"
  >
    <a-row :gutter="16">
      <a-col :span="10">
        <a-spin :spinning="loading">
          <a-list
            size="small"
            bordered
            :data-source="list"
            :locale="{ emptyText: '暂无录像' }"
          >
            <a-list-item
              slot="renderItem"
              slot-scope="item"
              :class="{ 'is-active': current && current.id === item.id }"
              style="cursor: pointer"
              @click="selectVideo(item)"
            >
              <a-list-item-meta
                :title="item.recordDate || item.createTime || item.id"
                :description="item.videoUrl"
              />
            </a-list-item>
          </a-list>
          <div style="margin-top: 12px; text-align: right">
            <a-pagination
              size="small"
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              @change="changePage"
            />
          </div>
        </a-spin>
      </a-col>
      <a-col :span="14">
        <mibo-video-player v-if="current && current.videoUrl" :src="current.videoUrl" :poster="current.coverUrl" />
        <div v-else style="padding: 48px; text-align: center; color: rgba(0,0,0,.45)">
          请选择左侧录像播放
        </div>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import { pageVideo } from '@/api/mibo/video'
import MiboVideoPlayer from '@/components/mibo/VideoPlayer'

export default {
  name: 'DeviceVideoModal',
  components: { MiboVideoPlayer },
  data () {
    return {
      visible: false,
      loading: false,
      title: '设备录像',
      list: [],
      total: 0,
      current: null,
      queryParam: {
        deviceId: null,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    open (record) {
      this.visible = true
      this.current = null
      this.list = []
      this.total = 0
      this.title = record && record.deviceName
        ? `设备录像 - ${record.deviceName}`
        : '设备录像'
      this.queryParam = {
        deviceId: record && record.id,
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },
    close () {
      this.visible = false
      this.current = null
      this.list = []
    },
    getList () {
      if (!this.queryParam.deviceId) {
        return
      }
      this.loading = true
      pageVideo(this.queryParam).then(res => {
        this.list = (res.data && res.data.records) || []
        this.total = (res.data && res.data.total) || 0
        if (this.list.length && !this.current) {
          this.current = this.list[0]
        }
      }).finally(() => {
        this.loading = false
      })
    },
    changePage (page) {
      this.queryParam.pageNum = page
      this.getList()
    },
    selectVideo (item) {
      this.current = item
    }
  }
}
</script>

<style scoped>
.is-active {
  background: #e6f7ff;
}
</style>
